/**
 * Tiktok 核价单 / 调价单联调示例（本地 localStorage，不调平台）。
 */

const DISCUSS_KEY_PREFIX = 'ipe.tiktok.pricing.discuss.demo.';
const ADJUST_KEY_PREFIX = 'ipe.tiktok.pricing.adjust.demo.';

function keyOf(prefix, shopId) {
  return `${prefix}${String(shopId || '')}`;
}

function readJson(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeJson(key, rows) {
  try {
    localStorage.setItem(key, JSON.stringify(rows));
  } catch {
    /* quota */
  }
}

function buildDiscussDemos() {
  const now = Date.now();
  return [
    {
      discussSn: 'DEMO-REVIEW-WAIT-001',
      orderSn: 'DEMO-REVIEW-WAIT-001',
      orderId: 'DEMO-REVIEW-WAIT-001',
      discussStatus: 0,
      status: 0,
      orderStatus: 0,
      productTitle: '示例卫衣 · 待核价',
      productName: '示例卫衣 · 待核价',
      mainPicUrl: 'https://picsum.photos/seed/ipe-tiktok-review-0/200/200',
      spuName: '80010001',
      skcName: '80020001',
      supplierCode: 'IPE-HV-001',
      productSkuIdList: [800001],
      productSkuId: 800001,
      siteNameList: ['美国站', '加拿大站'],
      siteCode: '美国站',
      supplyPrice: 2850,
      declarePrice: 2850,
      priceCurrency: 'CNY',
      suggestSupplyPrice: 2200,
      suggestPrice: 2200,
      suggestPriceCurrency: 'CNY',
      canBargain: false,
      negotiable: false,
      __demo: true,
      syncedAt: new Date(now).toISOString(),
    },
    {
      discussSn: 'DEMO-REVIEW-CONFIRM-001',
      orderSn: 'DEMO-REVIEW-CONFIRM-001',
      orderId: 'DEMO-REVIEW-CONFIRM-001',
      discussStatus: 1,
      status: 1,
      orderStatus: 1,
      productTitle: '示例连衣裙 · 待供应商确认',
      productName: '示例连衣裙 · 待供应商确认',
      mainPicUrl: 'https://picsum.photos/seed/ipe-tiktok-review-1/200/200',
      spuName: '80010002',
      skcName: '80020002',
      supplierCode: 'IPE-DR-002',
      productSkuIdList: [800002],
      productSkuId: 800002,
      siteNameList: ['美国站'],
      siteCode: '美国站',
      supplyPrice: 2000,
      declarePrice: 2000,
      priceCurrency: 'USD',
      suggestSupplyPrice: 1147,
      suggestPrice: 1147,
      suggestPriceCurrency: 'USD',
      canBargain: true,
      negotiable: true,
      __demo: true,
      skuCostPrices: [{
        skuCode: 'DEMO-SKU-REVIEW-002',
        saleAttributeValues: ['S'],
        latestCostPrice: 20.0,
        suggestCostPrice: 11.47,
        suggestCostCurrency: 'USD',
        costPriceHistories: [
          { serialNumber: 0, costPrice: 20.0, currency: 'USD' },
          { serialNumber: 1, costPrice: 20.0, currency: 'USD' },
        ],
      }],
      syncedAt: new Date(now).toISOString(),
    },
    {
      discussSn: 'DEMO-REVIEW-PASS-001',
      orderSn: 'DEMO-REVIEW-PASS-001',
      orderId: 'DEMO-REVIEW-PASS-001',
      discussStatus: 2,
      status: 2,
      orderStatus: 2,
      productTitle: '示例休闲裤 · 核价通过',
      productName: '示例休闲裤 · 核价通过',
      mainPicUrl: 'https://picsum.photos/seed/ipe-tiktok-review-2/200/200',
      spuName: '80010003',
      skcName: '80020003',
      supplierCode: 'IPE-PN-003',
      productSkuIdList: [800003],
      siteNameList: ['英国站'],
      supplyPrice: 1500,
      priceCurrency: 'CNY',
      suggestSupplyPrice: 1500,
      suggestPriceCurrency: 'CNY',
      canBargain: false,
      __demo: true,
      syncedAt: new Date(now).toISOString(),
    },
    {
      discussSn: 'DEMO-REVIEW-REJECT-001',
      orderSn: 'DEMO-REVIEW-REJECT-001',
      orderId: 'DEMO-REVIEW-REJECT-001',
      discussStatus: 3,
      status: 3,
      orderStatus: 3,
      productTitle: '示例外套 · 核价驳回',
      productName: '示例外套 · 核价驳回',
      mainPicUrl: 'https://picsum.photos/seed/ipe-tiktok-review-3/200/200',
      spuName: '80010004',
      skcName: '80020004',
      supplierCode: 'IPE-JK-004',
      productSkuIdList: [800004],
      siteNameList: ['德国站'],
      supplyPrice: 4500,
      priceCurrency: 'CNY',
      suggestSupplyPrice: 3000,
      suggestPriceCurrency: 'CNY',
      canBargain: false,
      __demo: true,
      syncedAt: new Date(now).toISOString(),
    },
  ];
}

function buildAdjustDemos() {
  const now = Date.now();
  return [
    {
      skc_name: '900101',
      skcName: '900101',
      skcId: 900101,
      orderSn: 'DEMO-ADJUST-WAIT-001',
      priceOrderSn: 'DEMO-ADJUST-WAIT-001',
      status: 0,
      priceType: 0,
      productName: '示例T恤 · 待调价',
      product_title: '示例T恤 · 待调价',
      productTitle: '示例T恤 · 待调价',
      spuName: '90010001',
      supplierCode: 'IPE-TS-101',
      image_url: 'https://picsum.photos/seed/ipe-tiktok-adjust-0/200/200',
      imageUrl: 'https://picsum.photos/seed/ipe-tiktok-adjust-0/200/200',
      adjustReason: '日常价调整示例',
      source: '运营',
      siteNameList: ['美国站'],
      trafficLowExpose: false,
      __demo: true,
      skuInfoList: [{
        productSkuId: 900001,
        price: 1800,
        newSupplyPrice: '1650',
        priceCurrency: 'USD',
        spec: 'S',
        rejectReason: '',
      }],
      updatedAt: new Date(now).toISOString(),
    },
    {
      skc_name: '900102',
      skcName: '900102',
      skcId: 900102,
      orderSn: 'DEMO-ADJUST-CONFIRM-001',
      priceOrderSn: 'DEMO-ADJUST-CONFIRM-001',
      status: 1,
      priceType: 1,
      productName: '示例卫衣 · 待供应商确认',
      product_title: '示例卫衣 · 待供应商确认',
      productTitle: '示例卫衣 · 待供应商确认',
      spuName: '90010002',
      supplierCode: 'IPE-HV-102',
      image_url: 'https://picsum.photos/seed/ipe-tiktok-adjust-1/200/200',
      imageUrl: 'https://picsum.photos/seed/ipe-tiktok-adjust-1/200/200',
      adjustReason: '活动价下调，请确认',
      source: '运营',
      siteNameList: ['美国站', '加拿大站'],
      trafficLowExpose: true,
      __demo: true,
      skuInfoList: [{
        productSkuId: 900002,
        price: 3200,
        newSupplyPrice: '2990',
        priceCurrency: 'USD',
        spec: 'M',
        rejectReason: '',
      }],
      updatedAt: new Date(now).toISOString(),
    },
    {
      skc_name: '900103',
      skcName: '900103',
      skcId: 900103,
      orderSn: 'DEMO-ADJUST-OK-001',
      priceOrderSn: 'DEMO-ADJUST-OK-001',
      status: 2,
      priceType: 0,
      productName: '示例短裤 · 调价成功',
      product_title: '示例短裤 · 调价成功',
      productTitle: '示例短裤 · 调价成功',
      spuName: '90010003',
      supplierCode: 'IPE-SH-103',
      image_url: 'https://picsum.photos/seed/ipe-tiktok-adjust-2/200/200',
      imageUrl: 'https://picsum.photos/seed/ipe-tiktok-adjust-2/200/200',
      adjustReason: '',
      source: '供应商',
      siteNameList: ['英国站'],
      __demo: true,
      skuInfoList: [{
        productSkuId: 900003,
        price: 1550,
        newSupplyPrice: '1550',
        priceCurrency: 'USD',
        spec: 'L',
      }],
      updatedAt: new Date(now).toISOString(),
    },
    {
      skc_name: '900104',
      skcName: '900104',
      skcId: 900104,
      orderSn: 'DEMO-ADJUST-FAIL-001',
      priceOrderSn: 'DEMO-ADJUST-FAIL-001',
      status: 3,
      priceType: 1,
      productName: '示例外套 · 调价失败',
      product_title: '示例外套 · 调价失败',
      productTitle: '示例外套 · 调价失败',
      spuName: '90010004',
      supplierCode: 'IPE-JK-104',
      image_url: 'https://picsum.photos/seed/ipe-tiktok-adjust-3/200/200',
      imageUrl: 'https://picsum.photos/seed/ipe-tiktok-adjust-3/200/200',
      adjustReason: '活动调价',
      source: '运营',
      siteNameList: ['德国站'],
      __demo: true,
      skuInfoList: [{
        productSkuId: 900004,
        price: 4900,
        newSupplyPrice: '4200',
        priceCurrency: 'USD',
        spec: 'XL',
        rejectReason: '价格低于活动底价',
      }],
      updatedAt: new Date(now).toISOString(),
    },
  ];
}

export function isTiktokDiscussDemoSn(sn) {
  return String(sn || '').startsWith('DEMO-REVIEW-');
}

export function isTiktokAdjustDemoSkc(skcName) {
  const s = String(skcName || '').trim();
  return s.startsWith('DEMO-SKC-ADJUST-') || s.startsWith('DEMO-ADJUST-') || /^90010[1-4]$/.test(s);
}

export function readTiktokDiscussDemos(shopId) {
  if (!shopId) return [];
  return readJson(keyOf(DISCUSS_KEY_PREFIX, shopId));
}

export function readTiktokAdjustDemos(shopId) {
  if (!shopId) return [];
  return readJson(keyOf(ADJUST_KEY_PREFIX, shopId));
}

/** @returns {{ count: number, items: object[] }} */
export function seedTiktokDiscussDemos(shopId) {
  const id = String(shopId || '').trim();
  if (!id) throw new Error('缺少店铺');
  const items = buildDiscussDemos();
  writeJson(keyOf(DISCUSS_KEY_PREFIX, id), items);
  return { ok: true, count: items.length, items };
}

/** @returns {{ count: number, items: object[] }} */
export function seedTiktokAdjustDemos(shopId) {
  const id = String(shopId || '').trim();
  if (!id) throw new Error('缺少店铺');
  const items = buildAdjustDemos();
  writeJson(keyOf(ADJUST_KEY_PREFIX, id), items);
  return { ok: true, count: items.length, items };
}

/**
 * 合并平台/缓存列表与本地示例；示例优先展示，并按 status 过滤。
 */
export function mergeTiktokDiscussWithDemos(shopId, apiItems = [], { statusFilter } = {}) {
  const demos = readTiktokDiscussDemos(shopId);
  const demoSns = new Set(demos.map((r) => String(r.discussSn || r.orderSn || '')));
  const real = (Array.isArray(apiItems) ? apiItems : []).filter((r) => {
    const sn = String(r?.discussSn || r?.orderSn || '');
    return !demoSns.has(sn) && !isTiktokDiscussDemoSn(sn);
  });
  let merged = [...demos, ...real];
  if (statusFilter !== '' && statusFilter != null && Number.isFinite(Number(statusFilter))) {
    const want = Number(statusFilter);
    merged = merged.filter((r) => Number(r.discussStatus ?? r.status ?? r.orderStatus) === want);
  }
  return merged;
}

export function mergeTiktokAdjustWithDemos(shopId, apiItems = [], { statusFilter } = {}) {
  const demos = readTiktokAdjustDemos(shopId);
  const demoKeys = new Set(demos.map((r) => String(r.skc_name || r.skcName || r.orderSn || '')));
  const real = (Array.isArray(apiItems) ? apiItems : []).filter((r) => {
    const k = String(r?.skc_name || r?.skcName || r?.orderSn || '');
    return !demoKeys.has(k) && !isTiktokAdjustDemoSkc(r?.skc_name || r?.skcName);
  });
  let merged = [...demos, ...real];
  if (statusFilter !== '' && statusFilter != null && Number.isFinite(Number(statusFilter))) {
    const want = Number(statusFilter);
    merged = merged.filter((r) => Number(r.status) === want);
  }
  return merged;
}

export function buildDiscussStatusCounts(items = []) {
  const counts = { all: 0, 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
  (Array.isArray(items) ? items : []).forEach((row) => {
    counts.all += 1;
    const s = Number(row?.discussStatus ?? row?.status ?? row?.orderStatus);
    if (Number.isFinite(s) && Object.prototype.hasOwnProperty.call(counts, s)) {
      counts[s] += 1;
      counts[String(s)] = (counts[String(s)] || 0) + 1;
    }
  });
  return counts;
}
